import React from "react";
import styles from "../style.module.scss";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import DownloadIcon from "@src/components/AccentIcons/DownloadIcon";

const DownloadReceipt = ({ data }) => {
  const { t } = useTranslation();
  const handleClick = () => {
    const deepLinkObj = {
      screen: "UTIL_DOWNLOAD",
      paramOne: data?.receiptUrl,
      paramTwo: data?.receiptUrl.substring(
        data?.receiptUrl.lastIndexOf("/") + 1
      ),
    };
    directDeepLink({}, "UTIL_DOWNLOAD", false)(deepLinkObj);
    // handleStartDownloadContent();
    //  window?.mobile?.performAction?.(
    //    `${"ACTION_DOWNLOAD_FILE"}`,
    //    JSON.stringify(newObj)
    //  );
  };
  const orgId = useSelector(
    (state) => state?.persistedDataReducer?.orgDetails?.organization.id 
  );
  return (
    <div className={styles.DownloadReceipt} onClick={() => handleClick()}>
      <div className={styles.DownloadReceipt__Left}>
        <DownloadIcon />
      </div>
      <div className={styles.DownloadReceipt__Right}>
        { orgId == 573212
        ? 'Download Invoice' : t(
          "components.tabs.overview.components.Pricing.downloadReceipt",
          "Download Receipt"
        )}
      </div>
    </div>
  );
};

export default DownloadReceipt;
